
import React from 'react';
import { useApp } from '../../context/AppContext';
import { Shield, ArrowRight, Wallet } from 'lucide-react';

const Welcome: React.FC = () => {
  const { setCurrentScreen } = useApp();

  return (
    <div className="flex flex-col h-full items-center justify-between py-8">
      <div className="w-full text-center mt-12">
        <div className="flex justify-center mb-6">
          <div className="bg-neobank-primary p-4 rounded-full">
            <Wallet className="w-12 h-12 text-white" />
          </div>
        </div>
        <h1 className="text-4xl font-bold mb-2 text-neobank-dark">CoinPrime</h1>
        <p className="text-lg text-gray-600 mb-8">Crypto to cash, simplified.</p>
        
        <div className="space-y-6 px-4 mt-8 mb-16">
          <div className="flex items-center">
            <div className="bg-neobank-lightAccent p-3 rounded-full mr-4">
              <Wallet className="w-6 h-6 text-neobank-primary" />
            </div>
            <div className="flex-1">
              <h3 className="font-medium">Fast Transactions</h3>
              <p className="text-sm text-gray-600">Convert crypto to cash instantly</p>
            </div>
          </div>
          
          <div className="flex items-center">
            <div className="bg-neobank-lightAccent p-3 rounded-full mr-4">
              <Shield className="w-6 h-6 text-neobank-primary" />
            </div>
            <div className="flex-1">
              <h3 className="font-medium">Secure & Private</h3>
              <p className="text-sm text-gray-600">Your data is always protected</p>
            </div>
          </div>
        </div>
      </div>
      
      <div className="w-full px-6">
        <button onClick={() => setCurrentScreen('register')} className="btn-primary mb-4 flex items-center justify-center">
          Get Started <ArrowRight className="ml-2 w-4 h-4" />
        </button>
        <button onClick={() => setCurrentScreen('login')} className="btn-outline">
          Log In
        </button>
      </div>
    </div>
  );
};

export default Welcome;
